import { enqueueSnackbar } from 'notistack';
import { handleErrors } from '../../../../utils/functions';
import { showAlert } from '../../../../redux/slices/appSlice';
import { useAppDispatch } from '../../../../hooks/reduxHooks';
import { useCallback, useMemo, useState } from 'react';
import { useDeleteRolMutation, useGetRolesQuery } from '../../../../services/adminApi';

function useRoles() {
    const dispatch = useAppDispatch();
    const [filterModelValue, setFilterModelValue] = useState<string>('');
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [drawerAction, setDrawerAction] = useState<string>('');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const {
        data: roles,
        isLoading: loadingRoles,
        isFetching: fetchingRoles
    } = useGetRolesQuery({}, { refetchOnMountOrArgChange: true });
    const [deleteRole, { isLoading: deletingRole }] = useDeleteRolMutation();

    const btnSelectStyle = useMemo(
        () => `& .MuiDataGrid-actionsCell button[aria-label="menuItemBtn-${selectedItem?.id}"]`,
        [selectedItem]
    );

    const handleCloseMenu = () => {
        setSelectedItem(null);
        setAnchorEl(null);
    };

    const onInputChange = useCallback((e: any) => {
        setFilterModelValue(e?.target?.value || '');
    }, []);

    const handleCloseDrawer = useCallback(() => {
        setDrawerAction('');
        if (selectedItem) setSelectedItem(null);
        // eslint-disable-next-line
    }, [selectedItem]);

    const handleOpenDrawer = useCallback((value: string = '') => {
        setDrawerAction(value);
    }, []);

    const handleMenuAction = useCallback((params: any, event: any) => {
        setSelectedItem(params);
        setAnchorEl(event.currentTarget);
    }, []);

    const handleDeleteRole = useCallback((item: any) => {
        const submit = async () => {
            const response: any = await deleteRole(item?.id);
            if (!response?.error) {
                setSelectedItem(null);
                enqueueSnackbar(response?.data?.message || 'Rol eliminado correctamente.', {
                    variant: 'success'
                });
            } else {
                handleErrors(response?.error);
            }
        };

        dispatch(
            showAlert({
                title: '¿Eliminar rol?',
                message: `Si eliminas '${item?.row?.nombre}' ya no estará disponible`,
                keepMounted: true,
                cancelText: 'Cancelar',
                confirmText: 'Sí, eliminar',
                confirmAction: submit
            })
        );
        // eslint-disable-next-line
    }, []);

    const handleSubmitAction = (action: string) => {
        setAnchorEl(null);
        switch (action) {
            case 'view':
                return handleOpenDrawer('view');
            case 'edit':
                return handleOpenDrawer('edit');
            case 'delete':
                return handleDeleteRole(selectedItem);
            default:
                return;
        }
    };

    return {
        roles,
        drawerAction,
        loadingRoles,
        fetchingRoles,
        anchorEl,
        selectedItem,
        btnSelectStyle,
        filterModelValue,
        deletingRole,
        handleSubmitAction,
        handleCloseMenu,
        handleCloseDrawer,
        onInputChange,
        handleOpenDrawer,
        handleMenuAction
    };
}

export default useRoles;
